export const MAX_TICKET_FILES = 10;
export const MAX_TICKET_TOTAL_BYTES = 40 * 1024 * 1024;
const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;
const MAX_VIDEO_BYTES = 30 * 1024 * 1024;
const VIDEO_EXTENSION = /\.(mp4|mov|m4v|webm|avi|mkv|mpeg|mpg)$/i;

export const isTicketVideo = file => /^video\//i.test(file.type || '') || VIDEO_EXTENSION.test(file.name || '');

export function selectTicketFiles(files, existing = []) {
  const accepted = [];
  let totalBytes = existing.reduce((total, file) => total + file.size, 0);
  let error = '';

  for (const file of files) {
    const isVideo = isTicketVideo(file);
    const maxBytes = isVideo ? MAX_VIDEO_BYTES : MAX_DOCUMENT_BYTES;
    if (existing.length + accepted.length >= MAX_TICKET_FILES) {
      error = '10 pièces jointes maximum.';
      break;
    }
    if (file.size > maxBytes) {
      error = `${file.name} dépasse ${isVideo ? '30 Mo' : '10 Mo'}.`;
      continue;
    }
    if (totalBytes + file.size > MAX_TICKET_TOTAL_BYTES) {
      error = '40 Mo maximum pour l’ensemble des pièces jointes.';
      continue;
    }
    accepted.push(file);
    totalBytes += file.size;
  }
  return { accepted, error };
}

export function readTicketFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => resolve({
      name: file.name, type: file.type, size: file.size,
      data: event.target.result.split(',')[1],
    });
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
